import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('purchaseOrderReport', [booksMenu])
  .controller('purchaseOrderReportController', purchaseOrderReportController)
  .name;
  
/* @ngInject */ function purchaseOrderReportController($scope, BooksSvc, $q, BusyScreen, BooksSettings) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', status: 'A', includeDetail: false };
  $scope.data = {};

  /*-----------------------------------------------------*/
  /* Resets values on page when resetFilters() is called */
  /*-----------------------------------------------------*/
  $scope.resetFilters = function () {
    $scope.req = {
      reportFormat: 'PDF',
      status: 'A',
      includeDetail: false,
      accountID: '',
      poNumber: null,
      amount: null
    };
    $scope.data = {
      entity: 0,
      resetStartDate: true,
      resetEndDate: true,
      resetRequiredStartDate: true,
      resetRequiredEndDate: true
    };
  };

  /*--------------------------*/
  /* Static array of statuses */
  /*--------------------------*/
  $scope.statuses = [
    { display: 'ANY', status: 'A' },
    { display: 'OPEN', status: 'O' },
    { display: 'CLOSED', status: 'C' },
    { display: 'PAID', status: 'P' }
  ];

  /*****************************************************************************
   * getEntityNames */
  /**
   * Dataprovider source for the individual name input used in the "For" typeahead.
   * Returns a promise for the type ahead directive to wait for.
   *
   * @param  text  Current type ahead text
   * @return       Promise object for server response
   *****************************************************************************/
  $scope.getEntityNames = function (text) {
    var defer = $q.defer();
    BooksSvc.findAddressEntities(
      text,
      BooksSettings.ledgerEntityTypes(),
      true
    ).then(function (resp) {
      // findAddressEntities is used here for consistency as it is the same endPoint used in PurchaseOrder application.
      // This application doesn't need the addresses returned from the call so we are mapping an array of only the entities.
      // This was changed due to [BOOKS-337]
      var entities = resp.data
        .map(function (entityAndAddress) {
          return entityAndAddress.entity;
        })
        .sort(function (a, b) {
          return a.fullName
            .toLowerCase()
            .localeCompare(b.fullName.toLowerCase());
        });
      defer.resolve(entities);
    });
    return defer.promise;
  };

  /*------------------------------------------------*/
  /* Watches for changes to the entity selections   */
  /* and sets the entity id to 0 if not a valid id. */
  /*------------------------------------------------*/
  $scope.$watch('data.entity', function (entity) {
    var entitySelected = entity && angular.isObject(entity);
    $scope.req.entityID = entitySelected ? entity.id : 0;
  });

  /*------------------------*/
  /* Date format validation */
  /*------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.viewChartOfAccounts().then(function (resp) {
      var chartOfAccounts = resp.data;
      $scope.accounts = [];
      for (var i = 0; i < chartOfAccounts.length; i++)
        if (
          chartOfAccounts[i].type == 'Expense' ||
          chartOfAccounts[i].type == 'Trust'
        ) {
          $scope.accounts.push(chartOfAccounts[i]);
        }
      BusyScreen.setBusy(false);
    });
  });
}